/**
 * 表格中常见的操作区, 只内置了一些样式
 */

import React from 'react';
import {Divider, Space} from 'antd';
import styles from './index.module.scss';
import classNames from 'classnames';
import useAuth from 'Utils/Hooks/useAuth';
import {Auth} from 'Features/Auth';

interface OperateProps {
    children?: React.ReactNode[];
    className?: string;
}

const Operate: React.FC<OperateProps> = ({children, className}) => {
    const auth = useAuth();

    // 按权限过滤
    const childArr = React.Children.toArray(children).filter(item => {
        if (typeof item !== 'object') return true;
        if (!('type' in item)) return true;
        if (item.type !== Auth) return true;
        return auth(item.props.code) || item.props.action === 'disable';
    });

    return (
        <Space
            className={classNames(className, styles.root)}
            split={<Divider type="vertical" />}>
            {childArr}
        </Space>
    );
};

export default Operate;
